import React, { useEffect, Children, useContext, cloneElement } from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import { isFunction } from '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';
import { Drawer } from '../Drawer/Drawer.es.js';
import { PopoverBase } from '../PopoverBase/PopoverBase.es.js';
import { usePopover } from '../PopoverBase/usePopover.es.js';
import { PopoverContext } from './PopoverContext.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Popover = (_a) => {
  var _b = _a, {
    children,
    triggerEvent = "click",
    hasArrow,
    isOpen: isOpenProp,
    onClose,
    onOpen,
    triggerRef,
    placement,
    closeOnBlur = true,
    closeDelay = 200
  } = _b, props = __objRest(_b, [
    "children",
    "triggerEvent",
    "hasArrow",
    "isOpen",
    "onClose",
    "onOpen",
    "triggerRef",
    "placement",
    "closeOnBlur",
    "closeDelay"
  ]);
  const { isOpen, open, close, getTriggerProps, getPopoverProps } = usePopover({
    triggerEvent,
    onOpen,
    onClose,
    hasArrow,
    triggerRef,
    placement,
    closeOnBlur,
    closeDelay
  });
  useEffect(() => {
    if (typeof isOpenProp !== "boolean") {
      return;
    }
    if (isOpenProp) {
      open();
    }
    if (!isOpenProp) {
      close();
    }
  }, [close, isOpenProp, open]);
  return /* @__PURE__ */ React.createElement(PopoverContext.Provider, {
    value: { isOpen, open, close, getTriggerProps, getPopoverProps, rest: props }
  }, isFunction(children) ? children({ isOpen, close }) : children);
};
Popover.displayName = " Popover";
const Trigger = ({ children }) => {
  const child = Children.only(children);
  const { getTriggerProps } = useContext(PopoverContext);
  return cloneElement(child, getTriggerProps(child.props, child.ref));
};
Trigger.displayName = "Popover.Trigger";
const Content = (_c) => {
  var _d = _c, { children, drawerBreakpoint = "md" } = _d, props = __objRest(_d, ["children", "drawerBreakpoint"]);
  const isDrawer = useBreakpoint(drawerBreakpoint);
  const { isOpen, getPopoverProps, close, rest } = useContext(PopoverContext);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isDrawer ? /* @__PURE__ */ React.createElement(Drawer, __spreadValues({
    isVisible: isOpen,
    onClose: close
  }, rest), /* @__PURE__ */ React.createElement(Drawer.Content, __spreadProps(__spreadValues({}, props), {
    maxWidth: "100%"
  }), children)) : /* @__PURE__ */ React.createElement(PopoverBase, __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, getPopoverProps()), {
    onOpen: getPopoverProps().open
  }), rest), props), children));
};
Content.displayName = "Popover.Content";
var Popover$1 = Object.assign(Popover, { Trigger, Content });

export { Popover$1 as default };
//# sourceMappingURL=Popover.es.js.map
